var _path, _rect, _path2, _polygon, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _path8, _rect5, _circle, _line1, _line10, _line11, _line12, _line13, _rect6, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRecords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "no-records",
    viewBox: "0 0 650 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M580.42615,100.915h20.39868a13.07957,13.07957,0,0,0,13.07934-13.07959V69.644a13.0793,13.0793,0,0,0-13.07934-13.0791H63.62988A13.07925,13.07925,0,0,0,50.55042,69.644V87.83545A13.07952,13.07952,0,0,0,63.62988,100.915H83.47644a13.07952,13.07952,0,0,1,13.07947,13.07959v18.19092a13.07952,13.07952,0,0,1-13.07947,13.07959h-.048A13.07959,13.07959,0,0,0,70.349,158.34473v18.19091a13.07959,13.07959,0,0,0,13.07947,13.07959h2.87146a13.07939,13.07939,0,0,1,13.07934,13.07911v18.1914a13.08242,13.08242,0,0,1-10.38672,12.79932H63.62988a13.11634,13.11634,0,0,0-2.69275.28027H39.17542a13.07952,13.07952,0,0,0-13.07959,13.0791v18.19141a13.07962,13.07962,0,0,0,13.07959,13.07959H86.16919a13.0816,13.0816,0,0,1,10.38672,12.79883v18.1914a13.07952,13.07952,0,0,1-13.07947,13.07959h-.048A13.07918,13.07918,0,0,0,70.349,335.46436v18.1914a13.07918,13.07918,0,0,0,13.07947,13.0791h2.87146a13.07949,13.07949,0,0,1,13.07934,13.07959v18.19141a13.07949,13.07949,0,0,1-13.07934,13.07959H59.17542a13.0792,13.0792,0,0,0-13.07959,13.0791V442.356a13.0792,13.0792,0,0,0,13.07959,13.0791H573.13831A13.07921,13.07921,0,0,0,586.2179,442.356V424.16455a13.07921,13.07921,0,0,0-13.07959-13.0791H561.79773a13.07957,13.07957,0,0,1-13.07935-13.07959V379.81445a13.07957,13.07957,0,0,1,13.07935-13.07959h26.74a13.079,13.079,0,0,0,13.07935-13.0791v-18.1914a13.079,13.079,0,0,0-13.07935-13.07911h-8.11157a13.07961,13.07961,0,0,1-13.07959-13.07959v-18.1914a13.07961,13.07961,0,0,1,13.07959-13.07959h30.39868a13.07915,13.07915,0,0,0,13.07934-13.0791V246.76416a13.07915,13.07915,0,0,0-13.07934-13.0791h-46.166a13.07963,13.07963,0,0,1-13.07959-13.07959V202.41406a13.0817,13.0817,0,0,1,10.387-12.79883h26.57153a13.07941,13.07941,0,0,0,13.07935-13.07959V158.34473a13.07941,13.07941,0,0,0-13.07935-13.07959h-8.11157a13.07962,13.07962,0,0,1-13.07959-13.07959V113.99463A13.07962,13.07962,0,0,1,580.42615,100.915Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236.821,
    height: 348.652,
    x: 251.031,
    y: 93.108,
    fill: "#bf1422",
    rx: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9ae2b",
    d: "M411.10444,350.49848V401.0369H282.25237a5.22091,5.22091,0,0,1-5.22091-5.22091V113.05147a5.22091,5.22091,0,0,1,5.22091-5.22091H456.63078a5.22091,5.22091,0,0,1,5.22091,5.22091v237.447Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbe8ec",
    points: "411.104 401.037 411.104 350.498 461.852 350.498 411.104 401.037"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70.169,
    height: 42.124,
    x: 136.669,
    y: 156.311,
    fill: "#bf1422",
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 70.169,
    height: 42.124,
    x: 506.789,
    y: 269.74,
    fill: "#fd7a7f",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.643,
    height: 13.783,
    x: 529.552,
    y: 263.893,
    fill: "#bf1422",
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7a7f",
    d: "M98.98949,241.46682h59.862a18.77032,18.77032,0,0,1,18.73718,19.76161c-1.89009,36.25377-7.89543,75.1773-7.89543,75.1773s-52.6061,6.30333-59.35958,6.30333h-4.76935a14.61713,14.61713,0,0,1-14.22-18.00114L107.17863,258.17a14.61713,14.61713,0,0,0-14.22-18.00114h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b0e17",
    d: "M103.27278 342.83886h58.62767l-5.81011 26.10459 19.16057-83.48518a14.61714 14.61714 0 0 0-14.24673-17.88688h-9.33439a14.61714 14.61714 0 0 0-14.2102 11.1921L124.54382 331.517a14.61714 14.61714 0 0 1-14.2102 11.1921ZM73.04231 268.85413 78.97475 250.53a14.61713 14.61713 0 0 1 13.98383-10.36118h0a14.61713 14.61713 0 0 1 14.22 18.00114l-2.54258 10.68416Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf1422",
    d: "M161.00418,267.57139a14.61714,14.61714,0,0,1,14.24673,17.88688L143.48352,423.87309A14.61713,14.61713,0,0,0,157.73025,441.76l5.69444,0,79.37448-17.88685,31.76739-138.41481a14.61713,14.61713,0,0,0-14.24672-17.88688h-9.3344Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b0e17",
    d: "M257.0459,441.76h5.69444a14.61713,14.61713,0,0,0,14.04533-10.56877l6.6276-22.99368a14.61714,14.61714,0,0,1,14.04534-10.56877h1.59874l-100.9144,0h0a14.61711,14.61711,0,0,0-14.04533,10.56876L177.47,431.1912A14.61713,14.61713,0,0,1,163.42469,441.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7a7f",
    d: "M198.143,397.62875h1.59874a14.61713,14.61713,0,0,1,14.21112,18.03833l-2.40693,9.998,99.31566,0,2.40692-9.998a14.61713,14.61713,0,0,0-14.21111-18.03833h-1.59874Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 166.974,
    x2: 236.609,
    y1: 373.485,
    y2: 373.485,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 171.753,
    x2: 241.388,
    y1: 356.831,
    y2: 356.831,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 176.641,
    x2: 246.275,
    y1: 340.025,
    y2: 340.025,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 181.528,
    x2: 251.162,
    y1: 323.218,
    y2: 323.218,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 186.415,
    x2: 256.05,
    y1: 306.412,
    y2: 306.412,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 191.302,
    x2: 260.937,
    y1: 289.605,
    y2: 289.605,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 106.412,
    x2: 140.782,
    y1: 322.261,
    y2: 322.261,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 108.77,
    x2: 143.141,
    y1: 305.607,
    y2: 305.607,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 111.183,
    x2: 145.553,
    y1: 288.801,
    y2: 288.801,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 113.595,
    x2: 147.965,
    y1: 271.994,
    y2: 271.994,
    fill: "none",
    stroke: "#7b0e17",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M369.44158,226.25124H342.90365a2.91841,2.91841,0,0,1-2.52742-4.37762l13.269-22.98252,13.269-22.98252a2.91842,2.91842,0,0,1,5.05485,0l13.269,22.98252,13.269,22.98252a2.91841,2.91841,0,0,1-2.52742,4.37762Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.92,
    height: 24.684,
    x: 367.982,
    y: 184.541,
    fill: "#bf1422"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 369.442,
    cy: 217.759,
    r: 3.493,
    fill: "#bf1422",
    transform: "rotate(-84.345 369.442 217.759)"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 304.598,
    x2: 434.285,
    y1: 249.817,
    y2: 249.817,
    fill: "none",
    stroke: "#4d76b8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 304.598,
    x2: 434.285,
    y1: 273.384,
    y2: 273.384,
    fill: "none",
    stroke: "#4d76b8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 304.598,
    x2: 434.285,
    y1: 296.95,
    y2: 296.95,
    fill: "none",
    stroke: "#4d76b8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 304.598,
    x2: 434.285,
    y1: 320.516,
    y2: 320.516,
    fill: "none",
    stroke: "#4d76b8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 304.598,
    x2: 434.285,
    y1: 150.883,
    y2: 150.883,
    fill: "none",
    stroke: "#4d76b8",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 129.687,
    height: 48.241,
    x: 304.598,
    y: 70.24,
    fill: "#fde9eb",
    rx: 6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 201.185,
    x2: 231.505,
    y1: 222.325,
    y2: 222.325,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 201.185,
    x2: 231.505,
    y1: 231.064,
    y2: 231.064,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 201.185,
    x2: 231.505,
    y1: 239.803,
    y2: 239.803,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 75.78,
    y2: 75.78,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 84.519,
    y2: 84.519,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 93.259,
    y2: 93.259,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 389.475,
    y2: 389.475,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 398.214,
    y2: 398.214,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 507.975,
    x2: 538.296,
    y1: 406.954,
    y2: 406.954,
    fill: "none",
    stroke: "#e0ecee",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.677,
    cy: 432.054,
    r: 12.96,
    fill: "#e0ecee"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.397,
    cy: 401.094,
    r: 6.72,
    fill: "#e0ecee"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.355,
    cy: 407.814,
    r: 9.6,
    fill: "#e0ecee"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.591,
    cy: 202.936,
    r: 15.42,
    fill: "#e0ecee"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.125,
    cy: 191.954,
    r: 8.032,
    fill: "#e0ecee"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.503,
    cy: 164.65,
    r: 4.633,
    fill: "#e0ecee"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.15,
    cy: 167.929,
    r: 11.107,
    fill: "#e0ecee"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.744,
    cy: 113.387,
    r: 15.42,
    fill: "#e0ecee"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.37,
    cy: 81.948,
    r: 8.032,
    fill: "#e0ecee"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.867,
    cy: 86.641,
    r: 6.952,
    fill: "#e0ecee"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.577,
    cy: 79.885,
    r: 4.633,
    fill: "#e0ecee"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.961,
    cy: 105.174,
    r: 11.107,
    fill: "#e0ecee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecords);
export default __webpack_public_path__ + "static/media/noRecords.7cf8ec20fe6739ad9ba88aa99a7f85e4.svg";
export { ForwardRef as ReactComponent };